
import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { EXCEL_HEADERS, EXCEL_URL } from '../helpers/constants';
import { GREEN, RED, YELLOW, WHITE, BLUE } from '../helpers/constants/colors';
import { DUMMY, excelPayload } from '../helpers/functions';
import Emoji from './Emoji';
import { useNavigate } from "react-router-dom";
import { BudgetContext } from '../context';

const BudgetAction = ({
    handleReset = DUMMY("reset"),
    handleLoadSave = DUMMY("load save"),
}) => {
    const {incomes, expenses} = useContext(BudgetContext)

    const navigate = useNavigate()
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        axios.get(EXCEL_URL)
            .then(() => setLoaded(true))
            .catch(() => setLoaded(false))
    }, [])

    const handleDownload = (e) => {
        e.preventDefault()
        console.log(excelPayload(incomes, expenses))
        axios.post(`${EXCEL_URL}/excel`, excelPayload(incomes, expenses), EXCEL_HEADERS)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'report.xlsx'); //or any other extension
                document.body.appendChild(link);
                link.click();
            }).catch(err => {
                console.log(err)
                if (incomes.length <= 0 && expenses.length <= 0)
                    alert("Cannot generate report of empty table")
            })
    }
    return (
        <div className='BudgetAction' align="center">
            <br />
            <Button onClick={handleReset} variant={RED}>Clear All<Emoji symbol='❌' /></Button>
            <Button onClick={() => navigate("/report")} variant={YELLOW}>Report Bug <Emoji symbol='🐞' /></Button>
            <Button disabled={!loaded} onClick={handleLoadSave} variant={GREEN}>Load/Save <Emoji symbol='💾' /></Button>
            <Button disabled={!loaded} onClick={handleDownload} variant={BLUE}>Download Report <Emoji symbol='📝' /></Button>
            <Button onClick={() => navigate("/about")} variant={WHITE}>About <Emoji symbol='ℹ️' /></Button>

        </div>
    )
}

export default BudgetAction;
